<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Welfare Discussion
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <report-comment
        field_name="heading_body_condition_scoring"
        :model="model.COMMENTS"
        :heading="true"
      ></report-comment>

      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-bcs`"
        v-for="farm in model.FARMS"
        :key="`farm_${farm.id}`"
      >
        <dl class="dl-horizontal">
          <dt>Date pre-Calving BCS is expected?</dt>
          <dd>{{ model[`farm_${farm.id}-bcs_precalv_exp_date`] || '-' }}</dd>

          <dt>Date pre-Mating BCS is expected?</dt>
          <dd>{{ model[`farm_${farm.id}-bcs_premate_exp_date`] || '-' }}</dd>

          <dt>Total Number of BCS's this season?</dt>
          <dd>{{ model[`farm_${farm.id}-bbcs_number_req_ns`] || '-' }}</dd>

          <dt>Interested in Tail scoring?</dt>
          <dd>{{ model[`farm_${farm.id}-wants_tail_scoring`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection
        :title="`Season BCS Fees Charged ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-bcs_fee`"
        v-for="farm in model.FARMS"
        :key="`bcs_farm_${farm.id}`"
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bcsfee, index) in model.CHARTS.bcs_fees[farm.id]" :key="'bcsfee_' + index">
              <td class="text-left">{{ bcsfee['Date'] }}</td>
              <td class="text-left">{{ bcsfee['Description'] }}</td>
              <td class="text-left">{{ bcsfee['Quanity'] }}</td>
            </tr>
          </tbody>
        </table>
      </subsection>

      <subsection
        :title="`Season AMU ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-amu`"
        v-for="farm in model.FARMS"
        :key="`amu_${farm.id}`"
      >
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Class</th>
              <th>Shed mg/kg</th>
              <th>Client mg/kg</th>
              <th>Region avg. mg/kg</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fsa, index) in model.CHARTS.cd_farm_season_amu[farm.id]" :key="'fsa_' + index">
              <td class="text-left">{{ fsa['class'] }}</td>
              <td class="text-left">{{ fsa['shed_mg_kg'] }}</td>
              <td class="text-left">{{ fsa['client_mg_kg'] }}</td>
              <td class="text-left">{{ fsa['region_mg_kg'] }}</td>
            </tr>
          </tbody>
        </table>
      </subsection>

      <subsection title="NSAID" :step-name="stepName" subsection="two_year_nsaid_table">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Product</th>
              <th>{{ seasonStartYear - 2 }}/{{ seasonStartYear - 1 }}</th>
              <th>{{ seasonStartYear - 1 }}/{{ seasonStartYear }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(nsaid, index) in model.CHARTS.nsaid_data" :key="'nsaid' + index">
              <td class="text-left">{{ nsaid['product'] }}</td>
              <td class="text-left">{{ nsaid['season_start_1'] }}</td>
              <td class="text-left">{{ nsaid['season_start'] }}</td>
            </tr>
          </tbody>
        </table>
      </subsection>

      <subsection
        :title="`Lame cows ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-bcs`"
        v-for="farm in model.FARMS"
        :key="'lame_cows_' + farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Number of cows treated last season?</dt>
          <dd>{{ model[`farm_${farm.id}-lame_cows_treated`] || '-' }}</dd>

          <dt>Welfare concerns/comments</dt>
          <dd>{{ model[`farm_${farm.id}-lame_cows_welfare_comments`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Staff training - how to treat lame cows?</dt>
          <dd>{{ model[`farm_${farm.id}-wants_lame_treatment_training`] || '-' }}</dd>

          <dt>Lameness Discussion</dt>
          <dd>
            <report-comment
              :field_name="`farm_${farm.id}-lameness_discussion`"
              :model="model.COMMENTS"
              :heading="false"
            ></report-comment>
          </dd>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import { BACKEND_URL } from '@/_services'

export default {
  name: 'WelfareMonitoring',
  mixins: [mixin],
  methods: {
    chartUrl: function (path) {
      return `${BACKEND_URL}${path}`
    },
  },
  computed: {
    nsaidData: function () {
      return Array.from(this.model.CHARTS.nsaid_data || []).sort((a, b) => b.sort - a.sort)
    },
  },
}
</script>
